import { useDialog } from "@shared/features/dialog/useDialog";
import VideoUIControlsEndMeeting from "./VideoUIControlsEndMeeting";

export function VideoUIControlsEndMeetingContainer() {
  const { openDialog } = useDialog();

  return <VideoUIControlsEndMeeting onClick={() => openDialog("endMeeting")} />;
}

export default VideoUIControlsEndMeetingContainer;
